import {Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {DispatcherService, ToastService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

const submitTypes = {
  SUBMIT: 1,
  SIGN: 2
};

@Directive({
  selector: '[siSubmit]'
})
export class SubmitDirective implements OnInit, OnDestroy {
  @Output() siSubmit = new EventEmitter<any>();
  @Input() siSubmitButtonText: string;
  @Input() siSubmitHideIcon: boolean;
  @Output() siSubmitSign = new EventEmitter<any>();

  ngSubmitSubscription: Subscription;
  statusChangesSubscription: Subscription;
  formName: string;
  submitType: number;
  private _siSubmitReadMode: boolean;

  constructor(
    private element: ElementRef,
    private form: NgForm,
    private dispatcher: DispatcherService,
    private renderer: Renderer2,
    private toastService: ToastService
  ) {
    this.formName = this.element.nativeElement.name;
  }

  get siSubmitReadMode() {
    return this._siSubmitReadMode;
  }

  @Input()
  set siSubmitReadMode(val) {
    this._siSubmitReadMode = val;
    this.showSubmitButton();
    this.showSignButton();
  }

  ngOnInit() {
    this.subscribeFormEvents();
    this.registerButtonsDispatcher();
    this.showSubmitButton();
    this.showSignButton();
  }

  registerButtonsDispatcher(): void {
    this.dispatcher.register('bottom-bar-submit', this.onFormSubmitClicked.bind(this), 'submitDirective');
    this.dispatcher.register('bottom-bar-sign', this.onFormSignClicked.bind(this), 'submitDirective');
  }

  showSubmitButton(): void {
    if (this.siSubmitReadMode) {
      this.dispatcher.exec('bottom-bar-show-submit-button', false, this.formName);
    } else {
      this.dispatcher.exec('bottom-bar-show-submit-button', true, this.formName, this.siSubmitButtonText, this.siSubmitHideIcon);
      this.enableDisableSubmitButton();
    }
  }

  showSignButton(): void {
    if (!this.siSubmitSign.observers.length) {
      return;
    }

    if (this.siSubmitReadMode) {
      this.dispatcher.exec('bottom-bar-show-sign-button', false, this.formName);
    } else {
      this.dispatcher.exec('bottom-bar-show-sign-button', true, this.formName);
    }
  }

  subscribeFormEvents(): void {
    this.ngSubmitSubscription = this.form.ngSubmit.subscribe(event => {
      this.onSubmit();
    });

    this.statusChangesSubscription = this.form.statusChanges.pipe(debounceTime(100)).subscribe(status => {
      this.onFormStatusChanges();
    });
  }

  onFormSubmitClicked(): void {
    this.submitType = submitTypes.SUBMIT;
  }

  onFormSignClicked(): void {
    this.submitType = submitTypes.SIGN;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.toastService.info('SI_COMPLETE_REQUIRED_FIELDS');
    } else if (this.submitType === submitTypes.SUBMIT) {
      this.siSubmit.emit();
    } else if (this.submitType === submitTypes.SIGN) {
      this.siSubmitSign.emit();
    }
  }

  onFormStatusChanges(): void {
    this.enableDisableSubmitButton();
  }

  enableDisableSubmitButton(): void {
    if (this.form.valid) {
      this.dispatcher.exec('bottom-bar-enable-button', true);
    } else {
      this.dispatcher.exec('bottom-bar-enable-button', false);
    }
  }

  ngOnDestroy() {
    if (this.ngSubmitSubscription) {
      this.ngSubmitSubscription.unsubscribe();
    }

    if (this.statusChangesSubscription) {
      this.statusChangesSubscription.unsubscribe();
    }

    this.dispatcher.unregisterFunction('bottom-bar-submit', 'submitDirective');
    this.dispatcher.unregisterFunction('bottom-bar-sign', 'submitDirective');
    this.dispatcher.exec('bottom-bar-hide-buttons', this.formName);
  }

}
